module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/invoice-form/invoice-form.component.css
// module id = ./src/app/invoice-form/invoice-form.component.css
// module chunks = main